<template>
    <div class="columns is-mobile is-centered has-background-primary p-2"  v-if="props.vista=='completa'">
        <h1 class="title is-4 has-text-white"><i class="fas fa-arrow-right-from-bracket"></i> &nbsp; DICO</h1>
    </div>

    <div class="box" @submit.prevent="" v-if="formAttivo">

        <div class="columns">
            <div class="column">
                <div class="field buttons">
                    <button class="button is-light" v-if="props.vista=='completa'" @click="bAnnulla" :disabled="!dicoDaAggiornare">Annulla</button>
                    <button class="button is-light" v-if="props.vista=='ridotta'" @click="bChiudi">Chiudi</button>
                    <button class="button is-primary" @click="bSalva" :disabled="!dicoDaAggiornare">Salva</button>
                </div>                
            </div>
            <div class="column" v-if="props.vista=='completa'">
                <p>
                    <a @click="gestisciSelezioneElemento({tipo: 'cliente', idCliente: props.idCliente})" title="Vai al cliente">
                        <i class="fas fa-user"></i> &nbsp; {{ generaStringaCliente(props.idCliente) }}
                    </a>
                </p>
            </div>
            <div class="column" v-if="props.vista=='completa'">
                <p>
                    <a @click="gestisciSelezioneElemento({tipo: 'lavoro', idCliente: props.idCliente, idLavoro: props.idLavoro})" title="Vai al lavoro">
                        <i class="fas fa-arrow-right-from-bracket"></i> &nbsp; {{ leggiInfoDB(dbClienti[props.idCliente]?.lavori?.[props.idLavoro])?.stringaLavoroCorta }}
                    </a>
                </p>
            </div>
            <div class="column">
                <div class="field buttons is-right">
                    <button class="button is-danger" @click="bElimina" v-if="idElementoSelezionato!=-1">Elimina</button>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column is-1">
                <CampoNumero @valoreCambiato="dicoModifica"
                    :valore=elementoSelezionato.numero
                    identificativo="numero"
                    etichetta="Numero"
                    formato="Flat"
                    allineamento="Centro"
                    tipo="Intero"
                    tipoBottone="numeroDico"/>
            </div>
            <div class="column is-2">
                <CampoData @valoreCambiato="dicoModifica"
                    :valore=elementoSelezionato.data
                    identificativo="data"
                    etichetta="Data"/>
            </div>
            <div class="column is-5">
                <div class="field">
                    <label class="label">Oggetto</label>
                    <div class="control">
                        <input class="input" type="text" v-model="elementoSelezionato.oggetto"  @change="dicoModifica(elementoSelezionato.oggetto, 'oggetto')">
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <CampoTendina @valoreCambiato="(valore)=>dicoModifica(valore, 'stato')"
                    :valore=elementoSelezionato.stato
                    idTendina="dico.stato"
                    etichetta="Stato"/>
            </div>
        </div>
    </div>

    <MessaggioModale @selezionato="bComandoModale"
        :confMessaggioModale=messaggioModale
        v-if="messaggioModale"/>

</template>

<script setup>
    import CampoData from "./CampoData.vue";
    import CampoNumero from "./CampoNumero.vue";
    import CampoTendina from "./CampoTendina.vue";
    import MessaggioModale from "./MessaggioModale.vue";
    // FIX: Aggiunto watch
    import { defineProps, defineEmits, ref, nextTick, watch } from "vue";
    import { dbClienti, salvaDicoInFirestore, eliminaDicoInFirestore, leggiInfoDB, leggiInfoDBRaw, aggiungiInfoDB } from "./../code/gestioneDB";
    // FIX: Aggiunto generaStringaCliente
    import { generaIdDico, clonaOggetto, generaStringaCliente } from "./../code/utilita";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        idDico: {
            type: Number,
            default: -1
        },
        idLavoro: {
            type: Number,
            required: true
        },
        idCliente: {
            type: Number,
            required: true
        },
        vista: {                    // completa, ridotta
            type: String,
            default: 'completa'
        }
    });
    const emit = defineEmits(['elementoSelezionato', 'modificaElementoInCorso']);

    // VARIABILI DEL COMPONENTE
    // FIX: Trasformati da let a const per la sicurezza del ref e inizializzazione a {}
    const elementoSelezionato = ref({});                    
    const dicoDaAggiornare = ref(null);              
    const messaggioModale = ref(null);               
    const idElementoSelezionato = ref(props.idDico || -1);
    const formAttivo = ref(true);                   

    // FIX: Watcher di sicurezza per cambi asincroni (allineato a FormLead)
    watch(() => props.idDico, (nuovoId) => {
        idElementoSelezionato.value = nuovoId || -1;
        setupForm();
    });

    // SETUP DEL COMPONENTE
    setupForm();

    // FUNZIONI DEL COMPONENTE
    function setupForm() {
        const id = idElementoSelezionato.value;

        // FIX: Scheletro di Base 
        const scheletroBase = {
            numero: null,
            data: null,
            oggetto: null,
            stato: null
        };

        if ( id == -1 ) {
            elementoSelezionato.value = { ...scheletroBase };
            aggiungiInfoDB(elementoSelezionato.value, {
                id: -1,
                idCliente: props.idCliente,
                idLavoro: props.idLavoro,
                stringaCliente: generaStringaCliente(props.idCliente)
            });
        } else {
            // FIX: Estrazione Sicura
            const clienteOriginale = dbClienti.value[props.idCliente];
            const lavoroOriginale = (clienteOriginale && clienteOriginale.lavori) ? clienteOriginale.lavori[props.idLavoro] : null;
            const dicoOriginale = (lavoroOriginale && lavoroOriginale.dico) ? lavoroOriginale.dico[id] : null;

            if (dicoOriginale) {
                elementoSelezionato.value = { ...scheletroBase, ...clonaOggetto(dicoOriginale) };
                
                // FIX: Ricostruisce i metadati (DNA) per il clone orfano
                const infoRaw = leggiInfoDBRaw(dicoOriginale) || { id: id, idCliente: props.idCliente, idLavoro: props.idLavoro };
                aggiungiInfoDB(elementoSelezionato.value, infoRaw);
            } else {
                elementoSelezionato.value = { ...scheletroBase };
                aggiungiInfoDB(elementoSelezionato.value, { id: id, idCliente: props.idCliente, idLavoro: props.idLavoro });
            }
        }
        dicoDaAggiornare.value = null;
    }

    function dicoModifica(valore, etichetta) {
        if (dicoDaAggiornare.value == null) {
            dicoDaAggiornare.value = {};
            emit('modificaElementoInCorso', true);
        }
        dicoDaAggiornare.value[etichetta] = valore;
        // Modifico anche l'elemento selezionato per coerenza coi v-model
        elementoSelezionato.value[etichetta] = valore;
    }

    function bChiudi() {
        if (dicoDaAggiornare.value != null) {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:null,
                testoDanger:{testo:'Chiudi senza salvare', comando:'chiudi'},
                messaggio:"Proseguendo perderai le modifiche fatte"
            };
        } else {
            emit('elementoSelezionato', {
                tipo: 'dico',
                idCliente: null,
                idLavoro: null,
                idDico: null
            });
        }
    }

    function bAnnulla() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:null,
            testoDanger:{testo:'Cancella le modifiche', comando:'cancella'},
            messaggio:"Proseguendo perderai le modifiche fatte"
        };
    }

    function bSalva() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:{testo:'Salva', comando:'salva'},
            testoDanger:null,
            messaggio:"Vuoi salvare le modifiche alla DiCo?"
        };
    }

    function bElimina() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:null,
            testoDanger:{testo:'Elimina', comando:'elimina'},
            messaggio:"Vuoi eliminare la DiCo?"
        };
    }

    async function bComandoModale(comando) {
        // FIX: Sicurezza estrazione ID per operare sul DB
        const tpIdCliente = leggiInfoDBRaw(elementoSelezionato.value)?.idCliente || props.idCliente;
        const tpIdLavoro = leggiInfoDBRaw(elementoSelezionato.value)?.idLavoro || props.idLavoro;

        // FIX: Raggruppati in scope isolati ({ }) per ESLint
        switch (comando) {
            case 'annulla': {
                messaggioModale.value = null;
                break;
            }
            case 'cancella': {
                emit('modificaElementoInCorso', false);
                messaggioModale.value = null;
                setupForm();
                resetForm();
                break;
            }
            case 'chiudi': {
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'dico',
                    idCliente: null,
                    idLavoro: null,
                    idDico: null
                });
                messaggioModale.value = null;
                break;
            }
            case 'salva': {
                if (idElementoSelezionato.value == -1) {
                    idElementoSelezionato.value = generaIdDico(tpIdCliente, tpIdLavoro);
                }
                aggiungiInfoDB(dicoDaAggiornare.value, {
                    id: idElementoSelezionato.value,
                    idCliente: tpIdCliente,
                    idLavoro: tpIdLavoro
                });
                await salvaDicoInFirestore(dicoDaAggiornare.value);
                setupForm();
                messaggioModale.value = null;
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'dico',
                    idCliente: tpIdCliente,
                    idLavoro: tpIdLavoro,
                    idDico: idElementoSelezionato.value
                });
                break;
            }
            case 'elimina': {
                eliminaDicoInFirestore(tpIdCliente, tpIdLavoro, idElementoSelezionato.value);
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'dicos'
                });
                break;
            }
        }
    }

    function gestisciSelezioneElemento(elSelezionato) {
        if (dicoDaAggiornare.value != null) {
            messaggioModale.value = {
                testoLight:{testo:'Ok', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Prima di uscire devi salvare o annullare le modifiche."
            };
        } else {
            emit('elementoSelezionato', elSelezionato);
        }
    }

    async function resetForm() {
        formAttivo.value = false;
        await nextTick();
        formAttivo.value = true;
    }
</script>